import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';

import { DarkModeProvider } from './context/DarkModeContext';
import { UserProvider } from './context/UserContext';
import Header from './components/Header';
import Footer from './components/Footer';
import AdBlockerNotice from './components/AdBlockerNotice';
import FeedbackWidget from './components/FeedbackWidget';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import OptionsBreakdown from './pages/OptionsBreakdown';
import IVCalculatorPage from './pages/IVCalculatorPage';
import ScripAnalysis from './pages/ScripAnalysis';
import BlogList  from './pages/blog/BlogList';
import BlogTheme from './pages/blog/BlogTheme';
import BlogPost  from './pages/blog/BlogPost';
import Account  from './pages/Account';
import Upgrade  from './pages/Upgrade';
import ContextApplier from './components/ContextApplier';
import DesignTest   from './pages/DesignTest';
import NotFound     from './pages/NotFound';
import { trackPageView } from './utils/analytics';

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <DarkModeProvider>
      <UserProvider>
      <BrowserRouter>
        <PageTracker />
        <ContextApplier />
        <div className="relative z-10 min-h-screen flex flex-col transition-colors duration-200">
          <AdBlockerNotice />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/how-it-works" element={<Navigate to="/blog/volatility-trading/how-to-use-iv-calculator" replace />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/options-breakdown" element={
                <ProtectedRoute featureKey="has_options_breakdown">
                  <OptionsBreakdown />
                </ProtectedRoute>
              } />
              <Route path="/iv-calculator" element={<IVCalculatorPage />} />
              <Route path="/scrip-analysis" element={<ScripAnalysis />} />
              <Route path="/blog"              element={<BlogList />} />
              <Route path="/blog/:theme"       element={<BlogTheme />} />
              <Route path="/blog/:theme/:slug" element={<BlogPost />} />
              <Route path="/design-test" element={<DesignTest />} />
              <Route path="/account"  element={<Account />} />
              <Route path="/upgrade"  element={<Upgrade />} />
              <Route path="*"         element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <FeedbackWidget />
        </div>
      </BrowserRouter>
      </UserProvider>
      </DarkModeProvider>
    </HelmetProvider>
  );
}
